export const titleTemplate = {
  metaInfo: {
    titleTemplate: (componentTitle) => {
      return componentTitle ? `${componentTitle} | BriteCore` : 'BriteCore'
    }
  }
}
